import { LoanOfferItem } from '@shared/sec-loans'
import { type NextStepEvent as CommonNextStepEvent, PreviousStepEvent } from '@ui-common/types'
import { setup } from 'xstate'

import { AuthenticatedContext, User } from '../../common/types'

export enum WizardStep {
  StatusStep = 'statusStep',
  OfferStep = 'offerStep',
  InstallmentStep = 'installmentStep',
  TermsInfoStep = 'termsInfoStep',
  RecommendationStep = 'recommendationStep',
  BookingStep = 'bookingStep',
  AfterCareStep = 'afterCareStep',
}

export type WizardContext = Partial<AuthenticatedContext> & {
  user: User
  loanOffer: LoanOfferItem
}

export type WizardMachineType = ReturnType<typeof createWizardMachine>

type BackToStatusEvent = { type: 'BACK_TO_STATUS' }

type WizardEvent = NextStepEvent | PreviousStepEvent | BackToStatusEvent

type NextStepEvent = CommonNextStepEvent<undefined>

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const createWizardMachine = () =>
  setup({
    types: {
      context: {} as WizardContext,
      events: {} as WizardEvent,
      input: {} as WizardContext,
    },
    actions: {},
    guards: {},
  }).createMachine({
    id: 'loanOfferWizardMachine',
    initial: WizardStep.StatusStep,
    context: ({ input }) => ({ ...input }),
    on: {
      BACK_TO_STATUS: { target: `.${WizardStep.StatusStep}` },
    },
    states: {
      [WizardStep.StatusStep]: {
        id: WizardStep.StatusStep,
        on: {
          NEXT_STEP: { target: WizardStep.OfferStep },
        },
      },
      [WizardStep.OfferStep]: {
        id: WizardStep.OfferStep,
        on: {
          PREVIOUS_STEP: { target: WizardStep.StatusStep },
          NEXT_STEP: { target: WizardStep.InstallmentStep },
        },
      },
      [WizardStep.InstallmentStep]: {
        id: WizardStep.InstallmentStep,
        on: {
          PREVIOUS_STEP: { target: WizardStep.OfferStep },
          NEXT_STEP: { target: WizardStep.TermsInfoStep },
        },
      },
      [WizardStep.TermsInfoStep]: {
        id: WizardStep.TermsInfoStep,
        on: {
          PREVIOUS_STEP: { target: WizardStep.InstallmentStep },
          NEXT_STEP: { target: WizardStep.RecommendationStep },
        },
      },
      [WizardStep.RecommendationStep]: {
        id: WizardStep.RecommendationStep,
        on: {
          PREVIOUS_STEP: { target: WizardStep.TermsInfoStep },
          NEXT_STEP: { target: WizardStep.BookingStep },
        },
      },
      [WizardStep.BookingStep]: {
        id: WizardStep.BookingStep,
        on: {
          PREVIOUS_STEP: { target: WizardStep.RecommendationStep },
        },
      },
      [WizardStep.AfterCareStep]: {
        id: WizardStep.AfterCareStep,
        on: {
          PREVIOUS_STEP: { target: WizardStep.RecommendationStep },
        },
      },
    },
  })
